module.exports = __webpack_public_path__ + "img/team-mosaic-01.5d226ab3.jpg";